<template>
    <div class="border-t border-gray-400 mt-6 pt-6 sm:border-none md:mt-0 sm:pt-0">
        <div class="absolute -mt-1 md:-mt-3 pl-1 md:pl-3">
            <i class="text-sm text-green-warm-500 fas fa-minus"></i>
        </div>

        <form-row title="Initial Earnest Money"
            :no_border="true"
            class="sm:mt-4"
            label_class="ml-8 md:ml-0 md:mt-6"
        >
            <div class="sm:-mt-4 md:mt-0 flex flex-col sm:flex-row flex-1 sm:items-end">
                <input-money
                    name="initial_earnest_money"
                    v-model="initial_amount"
                    :read_only="read_only"
                />

                <input-text
                    class="mt-4 sm:mt-0 sm:ml-4 flex-1"
                    label="Source of funds"
                    name="initial_earnest_source"
                    :value="deal.initial_earnest_source"
                    :read_only="read_only"
                />
            </div>
        </form-row>
    </div>
</template>

<script>
export default {
    props: {
        deal: { default: () => ({}) },
        value: {},
        read_only: { default: false },
    },

    computed: {
        initial_amount: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },
}
</script>
